import { createApi } from '@reduxjs/toolkit/query/react';
import { ApiResponse, IEecsAccount, IEecsGoAccount } from 'types';

import { apiBaseQuery } from 'modules/apiBaseQuery';

import {
  ConfirmConnectAccountPayload,
  ConnectAccountPayload,
  ConnectAccountResponse,
  DisconnectAccountPayload,
  GetGoAccountsPayload,
  SaveGoAccountsPayload,
} from '../types/grex.types';

export const grexApi = createApi({
  reducerPath: 'grexApi',
  baseQuery: apiBaseQuery(`${process.env.REACT_APP_API_URL}/v2/api/admin/grex`),
  endpoints: (builder) => ({
    connectAccount: builder.mutation<ApiResponse<ConnectAccountResponse>, ConnectAccountPayload>({
      query: (payload) => ({
        url: '/oauth/start',
        method: 'POST',
        body: payload,
      }),
    }),
    confirmConnectAccount: builder.mutation<ApiResponse<IEecsAccount>, ConfirmConnectAccountPayload>({
      query: (payload) => ({
        url: '/oauth/connect',
        method: 'POST',
        body: payload,
      }),
    }),
    disconnectAccount: builder.mutation<ApiResponse<void>, DisconnectAccountPayload>({
      query: (payload) => ({
        url: `/oauth/${payload.id}`,
        method: 'DELETE',
        body: payload,
      }),
    }),
    getGoAccounts: builder.mutation<ApiResponse<IEecsGoAccount[]>, GetGoAccountsPayload>({
      query: (payload) => ({
        url: `/${payload.id}/account-holders`,
        method: 'GET',
      }),
    }),
    setGoAccounts: builder.mutation<ApiResponse<void>, SaveGoAccountsPayload>({
      query: (payload) => ({
        url: `/${payload.id}/account-holders`,
        method: 'PUT',
        body: payload,
      }),
    }),
  }),
});

export const {
  useConnectAccountMutation,
  useConfirmConnectAccountMutation,
  useDisconnectAccountMutation,
  useGetGoAccountsMutation,
  useSetGoAccountsMutation,
} = grexApi;
